"use client";

import { useRouter } from "next/navigation";
import { Box } from "~/components/Box/Box";
import { Container } from "~/components/Container/Container";
import { VoucherCodePanel } from "~/components/VoucherCode/VoucherCodePanel";
import { useOrderingOptions } from "~/hooks/ordering-options";

export default function VoucherCodesPage(props: {
  params: { location: string };
}): React.ReactElement | null {
  const locationRef = props.params.location;

  const router = useRouter();

  const { dispatchOption } = useOrderingOptions(locationRef);

  return (
    <Container width="xsmall">
      <Box padding="3">
        <VoucherCodePanel
          onClickVoucherContinue={() =>
            router.push(`/${locationRef}/account/rewards`)
          }
          locationRef={locationRef}
          fulfillmentType={dispatchOption}
          design="classic"
          loading={false}
        />
      </Box>
    </Container>
  );
}
